/* @ngInject */
const compile = ($compile) => {
  return (scope, element, attrs) => {
    scope.$watch(
      (scope) => {
        return scope.$eval(attrs.compile)
      },
      (value) => {
        element.html(value)
        $compile(element.contents())(scope)
      }
    )
  }
}

export default compile



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/directives/compile.directive.js